import * as React from 'react';
import { Button } from './button';

/**
 * 인라인 확장 폼 카드 — 강조 헤더 + 본문(fieldset 그룹) + 푸터(취소/저장).
 * 예외처리 4탭 등록/수정 폼 공통 셸.
 */
export const FormCard: React.FC<{
  title: string;
  onClose: () => void;
  onSave: () => void;
  isSaving?: boolean;
  saveLabel?: string;
  children: React.ReactNode;
}> = ({ title, onClose, onSave, isSaving, saveLabel = '저장', children }) => (
  <div className="mb-6 overflow-hidden rounded-xl border border-border bg-card shadow-md">
    {/* 헤더 */}
    <div className="flex items-center justify-between bg-primary px-6 py-3.5">
      <span className="text-[0.95rem] font-bold text-primary-foreground">{title}</span>
      <button
        type="button"
        onClick={onClose}
        disabled={isSaving}
        aria-label="닫기"
        className="rounded bg-white/20 px-2 py-0.5 text-base leading-none text-primary-foreground hover:bg-white/30 disabled:opacity-50"
      >
        ×
      </button>
    </div>

    {/* 본문 */}
    <div className="flex flex-col gap-5 px-6 py-5">{children}</div>

    {/* 푸터 */}
    <div className="flex justify-end gap-3 border-t border-border bg-muted/30 px-6 py-3.5">
      <Button type="button" variant="outline" size="sm" onClick={onClose} disabled={isSaving}>
        취소
      </Button>
      <Button type="button" size="sm" onClick={onSave} disabled={isSaving}>
        {isSaving ? '저장 중...' : saveLabel}
      </Button>
    </div>
  </div>
);
